export default "__VITE_ASSET__51bf7607__$_?react__"